import React, { createContext, useState, useEffect } from 'react';
import { authAPI } from './api';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage on mount
  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }

    setLoading(false);
  }, []);

  const register = async (username, email, password, displayName) => {
    try {
      const response = await authAPI.register(username, email, password, displayName);
      const { user: newUser, token: newToken } = response.data;

      localStorage.setItem('token', newToken);
      localStorage.setItem('user', JSON.stringify(newUser));

      setToken(newToken);
      setUser(newUser);

      return newUser;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message || 'Erreur inscription';
      const err = new Error(errorMessage);
      throw err;
    }
  };

  const login = async (email, password) => {
    try {
      const response = await authAPI.login(email, password);
      const { user: loggedUser, token: newToken } = response.data;

      localStorage.setItem('token', newToken);
      localStorage.setItem('user', JSON.stringify(loggedUser));

      setToken(newToken);
      setUser(loggedUser);

      return loggedUser;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message || 'Erreur connexion';
      const err = new Error(errorMessage);
      throw err;
    }
  };

  const logout = () => {
    authAPI.logout();
    setUser(null);
    setToken(null);
  };

  const riotLogin = async (riotId, tagLine, region = 'euw1', email = null) => {
    try {
      const response = await authAPI.riotLogin(riotId, tagLine, region, email);
      const { user: loggedUser, token: newToken, isNewUser } = response.data;

      localStorage.setItem('token', newToken);
      localStorage.setItem('user', JSON.stringify(loggedUser));

      setToken(newToken);
      setUser(loggedUser);

      return { user: loggedUser, isNewUser };
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message || 'Erreur connexion Riot';
      const err = new Error(errorMessage);
      throw err;
    }
  };

  const updateProfile = async (updates) => {
    try {
      const response = await authAPI.updateProfile(updates);
      const updatedUser = response.data.user;

      localStorage.setItem('user', JSON.stringify(updatedUser));
      setUser(updatedUser);

      return updatedUser;
    } catch (error) {
      throw error.response?.data?.error || 'Erreur mise à jour';
    }
  };

  const loginWithToken = (newToken, newUser) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
  };

  const value = {
    user,
    token,
    loading,
    isAuthenticated: !!token,
    register,
    login,
    riotLogin,
    loginWithToken,
    logout,
    updateProfile
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
